/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const sectionStyle = {
  section: (theme: Theme) => ({
    marginBottom: "5rem",
    [theme.breakpoints.up("md")]: {
      marginBottom: "9rem",
    },
  }),
};
